import React from 'react';

import { shape, string } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../.internal/BaseComponent';

import './Table.scss';

export default class Table extends BaseComponent {
  render() {
    const { style, id, className, children } = this.props;

    const classNames = ClassNames(['Table', className]);

    return (
      <table style={style} id={id} className={classNames}>
        {children}
      </table>
    );
  }
}

Table.propTypes = {
  style: shape({}),
  id: string,
  className: string
};

Table.defaultProps = {
  style: {},
  id: undefined,
  className: undefined
};
